import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "fieldGroup"

export const presets = {}

export interface Props extends Component {}

export function FieldGroup({ children, className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`flex flex-col gap-6 md:flex-row`, className)} data-test={testId}>
      {children}
    </div>
  )
}
